// Status → antd Tag colour maps for the Broadcasts pages, consistent with the duty-assistant
// convention in ../statusColors.js (spec: broadcast-messages).
import React from 'react'
import { Tag } from 'antd'

// Broadcast (campaign) lifecycle.
export const BROADCAST_STATUS_COLORS = {
  draft: 'default',
  scheduled: 'geekblue',
  sending: 'processing',
  sent: 'green',
  paused: 'gold',
  failed: 'red'
}

// Per-recipient delivery lifecycle.
export const RECIPIENT_STATUS_COLORS = {
  pending: 'default',
  queued: 'blue',
  sent: 'geekblue',
  delivered: 'cyan',
  read: 'green',
  failed: 'red',
  skipped: 'orange'
}

export const broadcastStatusTag = status => (
  <Tag color={BROADCAST_STATUS_COLORS[status] || 'default'} style={{ marginBottom: 0 }}>
    {status}
  </Tag>
)

export const recipientStatusTag = status => (
  <Tag color={RECIPIENT_STATUS_COLORS[status] || 'default'} style={{ marginBottom: 0 }}>
    {status}
  </Tag>
)
